import config from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';

const fetchNotes = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/notes/all-notes`, { ...data });
};

module.exports = { fetchNotes };



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/ViewNotesList/ApiService.js